import { render, staticRenderFns } from "./confirmGA.popup-chunk.vue?vue&type=template&id=18be5509"
import script from "./confirmGA.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./confirmGA.popup-chunk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports